import { Component, OnInit } from '@angular/core';
import { PatientData } from '../../models/PatientData.model';
import { PatientServiceService } from '../../services/PatientService.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { AppComponent } from '../../../../app.component';

@Component({
  selector: 'app-paprofile-settings',
  templateUrl: './paprofile-settings.component.html',
  styleUrls: ['./paprofile-settings.component.css']
})
export class PaProfileSettingsComponent implements OnInit {
  htmlView: boolean = true;
  errHeader: string;
  errMessage: string[] = [];
  patientData: PatientData;
  updatedPatientData: PatientData;
  countries: any[];
  states: any[];
  showPercentage = false;
  loadingPercentage: number;
  profilePhoto: string;
  showOverlay: boolean;
  currentDate;
  constructor(private service: PatientServiceService, private appComponent: AppComponent) { }

  ngOnInit() {
    this.currentDate = new Date().toISOString().split("T")[0];

    this.updatedPatientData = new PatientData();
    this.showPercentage = false;
    this.getPatientData();
    this.getCountriesAndStates();
    this.htmlView = true;
  }

  alertClose() {
    setTimeout(() => {
      this.showOverlay = false;
    }, 4000);
  }

  getCountriesAndStates() {
    this.showOverlay = true;
    this.service.getCountriesAndStates().subscribe((data) => {
      this.countries = data["countries"];
      this.states = data["states"];
    }, err => {
        this.showOverlay = false;
      },() => { this.showOverlay = false; });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getPatientData() {
    this.showOverlay = true;
    this.service.getPatientProfileData().subscribe((data: PatientData) => {
      this.patientData = data;
      this.profilePhoto = this.patientData.photoUrl;
    }, err => {
      if (err.status === 400) {
        this.errHeader = 'Server Exception';
        this.errMessage = err.error;
        this.htmlView = false;
        this.showOverlay = false;
      }
    }, () => { this.htmlView = true; this.showOverlay = false; });
  }

  updatePatientData(form) {
    this.showOverlay = true;
    this.transferData(form);
    this.service.updatePatientProfile(this.updatedPatientData).subscribe((data) => {
      if (data != undefined) {
        this.alertClose();
        AlertMessages.Show('Updated', 'Profile Updated', AlertType.Success);
        this.firstComponentFunction();
      }
    }, err => {

      this.showOverlay = false;
    }, () => {
      this.showOverlay = false;
    });
  }

  transferData(form) {
    this.updatedPatientData.firstName = form.value.firstName;
    this.updatedPatientData.middleName = form.value.middleName;
    this.updatedPatientData.lastName = form.value.lastName;
    this.updatedPatientData.Dob = form.value.Dob;
    this.updatedPatientData.ssn = form.value.ssn;
    this.updatedPatientData.mobileNo = form.value.mobileNo;
    this.updatedPatientData.emailId = form.value.emailId;
    this.updatedPatientData.address = form.value.address;
    this.updatedPatientData.eaCountryId = form.value.country;
    this.updatedPatientData.eaState = form.value.state;
    this.updatedPatientData.zipCode = form.value.zipCode;
    this.updatedPatientData.city = form.value.city;
  }

  firstComponentFunction() {
    this.service.onFirstComponentButtonClick();
  }
}
